import script from "./statusPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./statusPopup.vue?vue&type=script&setup=true&lang=ts"

import "./statusPopup.vue?vue&type=style&index=0&id=46182300&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46182300"]])

export default __exports__